import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const TermsConditions = () => {
  return (
    <div className="min-h-screen pt-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4 lg:px-8 py-20">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Terms & <span className="text-[#0E6E6E]">Conditions</span>
          </h1>
          <p className="text-lg text-gray-600 mb-12">
            Last Updated: December 2025
          </p>

          <Card className="mb-8">
            <CardContent className="p-8 space-y-6">
              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  By engaging WealthOptimizers' services, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our services.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. About Our Services</h2>
                <p className="text-base text-gray-700 leading-relaxed mb-3">
                  WealthOptimizers is an AMFI-registered mutual fund distributor (ARN-XXXXX) providing:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-gray-700 ml-4">
                  <li>Mutual fund distribution and advisory services</li>
                  <li>Life and health insurance advisory</li>
                  <li>Goal-based financial planning</li>
                  <li>Retirement planning services</li>
                  <li>Investment portfolio review and rebalancing</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Client Responsibilities</h2>
                <p className="text-base text-gray-700 leading-relaxed mb-3">
                  As a client, you agree to:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-gray-700 ml-4">
                  <li>Provide accurate and complete information about your financial situation</li>
                  <li>Update us promptly about any changes in your financial circumstances</li>
                  <li>Complete KYC formalities as required by SEBI regulations</li>
                  <li>Read all scheme-related documents before investing</li>
                  <li>Make investment decisions based on your own judgment and risk appetite</li>
                  <li>Inform us of any concerns or complaints promptly</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Investment Risks and Disclaimer</h2>
                <p className="text-base text-gray-700 leading-relaxed mb-3">
                  <strong>Important:</strong> Mutual fund investments are subject to market risks. Please read all scheme-related documents carefully before investing.
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-gray-700 ml-4">
                  <li>Past performance is not indicative of future returns</li>
                  <li>We do not guarantee or assure any specific returns</li>
                  <li>Investment values may fluctuate based on market conditions</li>
                  <li>You may not recover your initial investment in full</li>
                  <li>Different investments carry different levels of risk</li>
                  <li>You are responsible for your investment decisions</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Advisory Nature</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  Our recommendations are advisory in nature. The final investment decision rests with you. We provide information and guidance based on your stated goals and risk profile, but we cannot control market outcomes or guarantee results.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Commission and Fees</h2>
                <p className="text-base text-gray-700 leading-relaxed mb-3">
                  As a mutual fund distributor, we may receive commissions from:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-gray-700 ml-4">
                  <li>Asset Management Companies for mutual fund distributions</li>
                  <li>Insurance companies for insurance product sales</li>
                </ul>
                <p className="text-base text-gray-700 leading-relaxed mt-3">
                  These commissions are paid by the product providers and do not result in additional charges to you. We maintain transparency about any fees or charges that may apply to specific services.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Confidentiality</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  We maintain strict confidentiality of your personal and financial information, except where disclosure is required by law or necessary for providing our services (e.g., to AMCs, RTAs, or regulatory authorities).
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Regulatory Compliance</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  We operate in full compliance with SEBI regulations, AMFI guidelines, and other applicable laws. Our services are subject to regulatory oversight, and we adhere to all prescribed codes of conduct.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Limitation of Liability</h2>
                <p className="text-base text-gray-700 leading-relaxed mb-3">
                  We shall not be liable for:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-gray-700 ml-4">
                  <li>Investment losses due to market conditions</li>
                  <li>Delays or failures by AMCs, RTAs, or other service providers</li>
                  <li>Consequences of information you provide being inaccurate or incomplete</li>
                  <li>Technical issues with third-party platforms or systems</li>
                  <li>Acts of God, government actions, or events beyond our control</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Complaints and Grievances</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  If you have any complaints or grievances, please contact us at Gauravsoni@wealthoptimizers.com. We aim to resolve all complaints within 30 days. If you are not satisfied with our resolution, you may escalate to AMFI or SEBI as per their grievance redressal procedures.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Termination of Services</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  Either party may terminate the advisory relationship by providing written notice. Termination does not affect existing investments, which will continue as per the terms of the respective schemes.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Communication</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  We may communicate with you via email, phone, WhatsApp, or other electronic means. You consent to receive investment-related communications, regulatory updates, and service information through these channels.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Intellectual Property</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  All content on our website, including text, graphics, logos, and software, is our property or licensed to us. You may not reproduce, distribute, or use this content without our written permission.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Changes to Terms</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  We reserve the right to modify these Terms and Conditions at any time. Changes will be posted on our website with the updated date. Your continued use of our services after changes constitutes acceptance of the modified terms.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">15. Governing Law</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  These Terms and Conditions are governed by the laws of India. Any disputes will be subject to the exclusive jurisdiction of courts in Pune, Maharashtra.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">16. Severability</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall continue in full force and effect.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">17. Contact Information</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  For questions about these Terms and Conditions, please contact:<br />
                  Email: Gauravsoni@wealthoptimizers.com<br />
                  AMFI Registration: ARN-XXXXX
                </p>
              </section>

              <section className="pt-6 border-t">
                <p className="text-base text-gray-700 leading-relaxed italic">
                  By using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
                </p>
              </section>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
